import * as React from 'react'
import { Grid, Typography, TextField, MenuItem } from '@material-ui/core'
import * as moment from 'moment'

import range from '../shared/range'
import formatCurrency from '../shared/formatCurrency'
import { IEvent } from 'src/models/IContest'

const quantities = range(0, 20)

interface ITicketsProps {
  events: IEvent[]
  onTicketsChange: (ticketID: number, quantity: number) => void
  ticketQuantities: ITicketQuantities
}

export interface ITicketQuantities {
  [ticketID: number]: number
}

class Tickets extends React.Component<ITicketsProps> {
  public render() {
    const { events, ticketQuantities } = this.props

    return (
      <>
        <Typography variant="h6" gutterBottom>
          Tickets
        </Typography>

        <Grid container spacing={16}>
          {events.map((event, i) => (
            <Grid item xs={12} key={event.eventID}>
              <Typography variant="h6">
                {moment(event.date).format('dddd M/D h:mm a')}
              </Typography>
              <Typography component="p" gutterBottom>
                {event.description}
              </Typography>

              <Grid container alignItems="center">
                {event.tickets.map(ticket => (
                  <React.Fragment key={ticket.ticketID}>
                    <Grid item xs={6}>
                      <Typography component="span">
                        {ticket.name} {formatCurrency(ticket.price)}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        select
                        fullWidth
                        label="Quantity"
                        value={ticketQuantities[ticket.ticketID] || 0}
                        name={`tickets[${ticket.ticketID}]`}
                        onChange={this.updateTickets.bind(
                          this,
                          ticket.ticketID
                        )}>
                        {quantities
                          .slice(0, ticket.isLiveStream ? 2 : undefined)
                          .map(n => (
                            <MenuItem key={n} value={n}>
                              {n || 'None'}
                            </MenuItem>
                          ))}
                      </TextField>
                    </Grid>
                  </React.Fragment>
                ))}
              </Grid>
            </Grid>
          ))}
        </Grid>
      </>
    )
  }

  private updateTickets = (
    ticketID: number,
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const quantity = Number(e.target.value)
    this.props.onTicketsChange(ticketID, quantity)
  }
}

export default Tickets



// WEBPACK FOOTER //
// ./src/components/contest/Tickets.tsx